import { ItiBaseDto } from '@/iti-core-vue';

export class Sector extends ItiBaseDto {
    public code !: string;
    public description !: string;
}